export const API_KEYS = ["d1fd27406d8eec426c5d4176f1caf667", "3f9412259538506f0666ba852038e2bf"] // 0 edu 1 marcos
export const API_CALLS = {
    trendingMovies: "https://api.themoviedb.org/3/trending/movie/week?api_key=",
    trendingSeries: "https://api.themoviedb.org/3/trending/tv/week?api_key=",
    movies:"https://api.themoviedb.org/3/movie/%7Bmovie_id%7D?api_key="
}
